import { ButtonElement } from "@redotech/redo-model/forge/marketing-signup-forge-types";
import { memo } from "react";
import { BrandKitButton } from "../../brand-kit-button";
import { FormElementProps } from "./index";

export const FormButton = memo(function FormButton({
  form,
  element,
  brandKit,
  onClose,
  ...props
}: FormElementProps<ButtonElement>) {
  if (element.action === "close" && !onClose) {
    return null;
  }

  return (
    <BrandKitButton
      brandKit={brandKit}
      hierarchy={element.hierarchy}
      onClick={() => {
        if (onClose && element.action === "close") {
          onClose();
        }
      }}
      override={
        form.theme.overrides.buttons.enabled
          ? form.theme.overrides.buttons
          : undefined
      }
      pending={props.submitting}
      text={element.text}
      type={element.action === "submit-and-advance" ? "submit" : "button"}
    />
  );
});
